import { logCompletion, logInteraction } from '@bosca/analytics-client-browser'
import type Plyr from 'plyr'
import type { ContentItemTypes } from '~/utils/graphql/graphql'

export function addPlayerEvents(
    player: Plyr,
    audio: boolean,
    item: ContentItemTypes | undefined,
    onPlay: (() => void) | undefined,
    overlayVisible: Ref<boolean> | undefined = undefined,
) {
    function newExtras() {
        return {
            audio: (audio || false).toString(),
            currentTime: player.currentTime ? player.currentTime?.toFixed(2) : '0.0',
            duration: player.duration ? player.duration?.toFixed(2) : '0',
        }
    }

    let overlayTimeout: any | null = null
    let playing = false

    function wasSeeking() {
        const time = new Date().getTime() - player.lastSeekTime
        if (time < 0) return false
        return time < 1000
    }

    function doOnPlay() {
        if ((overlayVisible && overlayVisible.value) || wasSeeking()) {
            return
        }

        logCompletion({
            id: 'play',
            type: 'button',
            content: item ? [{ id: item.id || '', type: item.__typename || '' }] : [],
            extras: newExtras(),
        })

        if (!playing) {
            playing = true
            if (player.muted) {
                player.muted = false
            }
            if (player.volume < 0.5) {
                player.volume = 0.5
            }
        }

        if (onPlay) {
            onPlay()
        }
    }

    function showOverlay() {
        if (overlayVisible) {
            if (overlayTimeout) clearTimeout(overlayTimeout)
            overlayTimeout = setTimeout(() => {
                overlayVisible.value = true
            }, 200)
        }
    }

    function clearShowOverlay() {
        if (overlayTimeout) {
            clearTimeout(overlayTimeout)
            overlayTimeout = null
        }
    }

    player.on('playing', doOnPlay)

    player.on('error', () => {
        showOverlay()
        logCompletion({
            id: 'play',
            type: 'button',
            content: item ? [{ id: item.id || '', type: item.__typename || '' }] : [],
            extras: { error: 'true', audio: audio.toString() },
        })
    })
    player.on('pause', () => {
        showOverlay()
        logInteraction({
            id: 'pause',
            type: 'button',
            content: item ? [{ id: item.id || '', type: item.__typename || '' }] : [],
            extras: newExtras(),
        })
    })
    player.on('seeking', () => {
        clearShowOverlay()
        logInteraction({
            id: 'seek',
            type: 'button',
            content: item ? [{ id: item.id || '', type: item.__typename || '' }] : [],
            extras: newExtras(),
        })
    })
    player.on('seeked', () => {
        clearShowOverlay()
        logCompletion({
            id: 'seek',
            type: 'button',
            content: item ? [{ id: item.id || '', type: item.__typename || '' }] : [],
            extras: newExtras(),
        })
    })
    player.on('ended', () => {
        showOverlay()
        logCompletion({
            id: 'player',
            type: 'media',
            content: item ? [{ id: item.id || '', type: item.__typename || '' }] : [],
            extras: newExtras(),
        })
    })
}
